
export const CollectCatCollisionEventId = "collectCats";

/**
 * @deprecated
 */
export const CollectCatCollisionEventName = "collectCatCollision";

